module.exports = __webpack_public_path__ + "media/images/athletes/3533-a414247f04312f2c2a1de956cfd7612b.png";